import { Search } from '@mui/icons-material';
import {
  Autocomplete,
  type AutocompleteProps,
  CircularProgress,
} from '@mui/material';
import {
  type TextFieldProps as PantryTextFieldProps,
  TextField,
} from '@side/pantry';

interface Props<T>
  extends Omit<AutocompleteProps<T, false, false, false>, 'renderInput'> {
  loading: boolean;
  TextFieldProps: PantryTextFieldProps;
}

export function AutocompleteSearchBox<
  T extends { id: string; label: string } | null,
>({ disabled, loading, TextFieldProps, ...rest }: Props<T>) {
  return (
    <Autocomplete
      id="location-autocomplete"
      getOptionLabel={(option) => option?.label ?? ''}
      noOptionsText="No Results"
      autoComplete
      fullWidth
      includeInputInList
      disabled={disabled}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={(params) => (
        <TextField
          {...params}
          LabelProps={{
            sx: {
              fontWeight: 'medium',
            },
          }}
          {...TextFieldProps}
          slotProps={{
            ...params.slotProps,
            ...TextFieldProps.slotProps,
            input: {
              ...params.slotProps.input,
              ...TextFieldProps.slotProps?.input,
              startAdornment: (
                <Search
                  color={disabled ? 'inherit' : 'action'}
                  sx={{ mr: -0.5 }}
                />
              ),
              endAdornment: loading ? (
                <CircularProgress sx={{ mr: 2, color: 'inherit' }} size={20} />
              ) : (
                params.slotProps.input.endAdornment
              ),
            },
          }}
        />
      )}
      popupIcon={null}
      {...rest}
    />
  );
}
